<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'
import { NuxtLink } from '#components'

const t2 = useT2({})

defineProps<{
  hide?: boolean
  to?: RouteLocationRaw
  txt: stringI18n
  txt2?: stringI18n
}>()
</script>

<template>
  <div :class="[typeof hide === 'boolean' && $style.hide, hide && $style.hideOn]">
    <component :is="to ? NuxtLink : 'button'" :to :class="['IconArrow', 'ButtonIcon', $style.a]">
      <ButtonIcon right :txt="txt2 || t2('Back')" to="span" :class="$style.btn"
        ><slot name="icon"><IconArrow left /></slot
      ></ButtonIcon>
      <span :class="$style.l">{{ txt }}</span>
    </component>
  </div>
</template>

<style module>
.a {
  composes: global(_fs1);
  composes: global(_fw-xl);
  composes: global(_pr2);
  composes: global(_gap1);
  composes: global(_h50);

  composes: global(_row);
  composes: global(_inline);
  composes: global(_ctrY);
  composes: global(_br22);
  composes: global(_wmax);

  composes: global(_spaced);

  min-width: 180px;

  composes: global(_bg1);
  composes: global(_c0);
}
:global(.d) .a:hover {
  border-color: var(--black-6);
}

.hide {
  composes: global(_w220);
  transition: width 200ms var(--tran2);
}
.hide.hideOn {
  width: 0;
  overflow: hidden;
}

.l {
  composes: global(_flex);
  composes: global(_txt_ctr);
}
:global(.d) .a:hover .l {
  color: var(--black-4);
}

.btn {
  composes: global(_ctr);
  margin-left: -1px;
}
</style>
